import { render, staticRenderFns } from "./SmallSkeleton.vue?vue&type=template&id=37374201&"
import script from "./SmallSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SmallSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports